import { Card, Table, Spin } from "antd";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getProductListBySiteId } from "@/services/api";
import { GAClickToBuy, GAClickMyproductRenew } from "@/ga/personCenter";
import moment from "moment";
import "./index.less";

/**
 * 产品信息列表组件
 * @returns
 */
const ProductList = () => {
  const [tableLoading, setTableLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [tableData, setTableData] = useState([]); //表格数据

  useEffect(() => {
    getProjectList();
  }, []);

  //获取产品列表
  const getProjectList = async () => {
    setPageLoading(true);
    setTableLoading(true);
    getProductListBySiteId({ site_id: 93 })
      .then((res) => {
        if (res.code === 200) {
          setTableData(res?.data);
          setTableLoading(false);
          setPageLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const columns = [
    {
      title: "产品名",
      dataIndex: "product_name",
      key: "product_name",
      align: "center",
      width: 282,
    },
    {
      title: "有效期",
      dataIndex: "expire_time",
      key: "expire_time",
      align: "center",
      width: 282,
      render: (_, option) => {
        if (option.expire_time === 0) {
          return "无限期";
        } else {
          return moment(parseInt(option.expire_time) * 1000).format(
            "YYYY-MM-DD"
          );
        }
      },
    },
    {
      title: "操作",
      dataIndex: "operation",
      key: "operation",
      align: "center",
      width: 282,
      render: (_, option) => {
        return (
          <a
            href={option?.buy_link}
            className="btn btn-primary btn-sm"
            key="renew"
            target="_blank"
            onClick={GAClickMyproductRenew}
          >
            续费
          </a>
        );
      },
    },
  ];

  return (
    <Spin spinning={pageLoading} tip="Loading">
      <Card
        title="我的产品"
        extra={() => null}
        bordered={false}
        className="product_card w-100 position-relative"
        headStyle={{ border: 0, fontWeight: 700, paddingBottom: 24 }}
      >
        {tableData.length > 0 ? (
          <Table
            rowKey="id"
            columns={columns}
            dataSource={tableData}
            loading={tableLoading}
            pagination={false}
            bordered
            rowClassName={(_, index) => {
              return index % 2 === 0 ? "oddRow" : "eventRow";
            }}
            className="product_table w-100 text-start"
          />
        ) : (
          <div className="empty_content text-center">
            <img
              src="https://images.niuxuezhang.cn/imgs/account-center/empty.png"
              alt=""
              className="mb-1"
            />
            <h4 className="fw-normal text-muted mb-4">当前没有购买产品</h4>
            <Link
              to="/personal-center/product-info"
              className="btn btn-primary btn-lg btn-vip fw-normal d-inline-flex"
              onClick={GAClickToBuy}
            >
              立即购买
            </Link>
          </div>
        )}
      </Card>
    </Spin>
  );
};

export default ProductList;
